import { Country } from '@efp/api'

export const allCountries: Country[] = Object.values(Country)
export const imperialCountries = [Country.Us]
